import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 中英文版 CN / EN
  {
    path: '/:lang',
    name: 'home',
    meta: {
      name: '',
      english: ''
    },
    component: () => import("@/views/index.vue")
  },
  {
    path: '/:lang/observer',
    name: 'observer',
    meta: {
      name: '观测者',
      english: 'Observer'
    },
    component: () => import("@/views/observer.vue")
  },
  {
    path: '/:lang/bigdataplatform',
    name: 'bigdataplatform',
    meta: {
      name: '城市数字孪生底座',
      english: 'Spatio-temporal big data platform'
    },
    component: () => import("@/views/BigData.vue")
  },
  {
    path: '/:lang/service',
    name: 'service',
    meta: {
      name: '城市低空服务系统',
      english: 'Low altitude service system'
    },
    component: () => import("@/views/service.vue")
  },
  {
    path: '/:lang/space',
    name: 'space',
    meta: {
      name: '城市建设监管系统',
      english: 'Urban space control system'
    },
    component: () => import("@/views/space1.vue")
  },
  {
    path: '/:lang/AK1',
    name: 'ak1',
    meta: {
      name: 'AK1',
      english: 'AK1'
    },
    component: () => import("../views/ak1.vue")
  },
  {
    path: '/:lang/AK2',
    name: 'ak2',
    meta: {
      name: 'AK2',
      english: 'AK2'
    },
    component: () => import("@/views/ak2.vue")
  },
  {
    path: '/:lang/AK3',
    name: 'ak3',
    meta: {
      name: 'Ak3',
      english: 'AK3'
    },
    component: () => import("@/views/ak3.vue")
  },
  {
    path: '/:lang/C5',
    name: 'c5',
    meta: {
      name: 'C5',
      english: 'C5'
    },
    component: () => import("@/views/c5.vue")
  },
  {
    path: '/:lang/catcher',
    name: 'catcher',
    meta: {
      name: '守望者',
      english: 'Catcher'
    },
    component: () => import("@/views/watcher.vue")
  },
  {
    path: '/:lang/collector',
    name: 'collector',
    meta: {
      name: '采集者',
      english: 'Collector'
    },
    component: () => import("@/views/gatherers.vue")
  },
  {
    path: '/:lang/about',
    name: 'about',
    meta: {
      name: '品牌故事',
      english: 'About us'
    },
    component: () => import("@/views/about.vue")
  },
  {
    path: '/:lang/contact',
    name: 'contact',
    meta: {
      name: '联系我们',
      english: 'Contact us'
    },
    component: () => import("@/views/contact.vue")
  },
  {
    path: "/*",
    redirect: '/CN'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if(!/about/i.test(to.path)) {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    window.scrollTo(0, 0)
  }
  if(!/\/EN\/|\/CN\//.test(`/${to.params.lang}/`)) {
    next({path: '/EN'})
    return
  }
  
  if(to.params.lang === 'EN') {
    let str = 'Airlook Defence-AIoT physical space application platform'
    let path = to.meta.english
    document.getElementsByTagName('title')[0].innerHTML = path ? `${path} | ${str}` : str
  }else {
    let str = '埃洛克航空 - 低空基础设施解决方案服务商' // '埃洛克防务 - AIoT物理空间应用平台'
    let path = to.meta.name
    document.getElementsByTagName('title')[0].innerHTML = path ? `${path} | ${str}` : str
  }
  next()
})
export default router
